import { Layout } from "../layout"

/**
 * Sets various styles on the actual containing element (scope) as well as a few
 * data attributes to help with CSS styling.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 */
export const styleGraph = data => {
  // Width of graph / width of nodes = max num of nodes across / wide
  const graphWidth = Math.floor(data.layout.width / Layout.maxNodeWidth)
  const minGraphWidth = data.roots.length ? 1 : 3

  if (graphWidth > 10) {
    data.scope.dataset.widthGreaterThan = 10
  } else if (graphWidth > 4) {
    data.scope.dataset.widthGreaterThan = 4
  }

  data.scope.dataset.width = Math.max(graphWidth, minGraphWidth)
  data.scope.style.margin = "0 auto"
  data.scope.style.position = "relative"

  return data
}

